import { MobileOnly } from "../../components/MobileOnly";
import { FilterPanelMobile } from "./FilterPanelMobile";
import { DesktopOnly } from "../../components/DesktopOnly";
import { FilterPanelDesktop } from "./FilterPanelDesktop";
import { Filter, FilterValue } from "../types/filter";

interface FilterPanelProps {
  useFiltersFactory: (
    filterValues: FilterValue[],
    setFilterValues: (values: FilterValue[]) => void
  ) => Filter[];
  filterValues: FilterValue[];
  setFilterValues: (filterValues: FilterValue[]) => void;
  feature: string;
}

// Main component to view filters.
export const FilterPanel = (props: FilterPanelProps) => {
  return (
    <>
      <MobileOnly>
        <FilterPanelMobile {...props} />
      </MobileOnly>
      <DesktopOnly>
        <FilterPanelDesktop {...props} />
      </DesktopOnly>
    </>
  );
};
